import { createContext, useContext } from 'react';

/**
 * Version d'interface rendue : 'v1' (app actuelle) ou 'v2' (nouvelle interface).
 *
 * Le choix est fait UNE fois, au montage (main.tsx → isUxV2()) ; ce contexte le rend lisible par
 * tout composant partagé entre les deux arbres sans relire window.mondayMindbody. Valeur par
 * défaut 'v1' : l'arbre v1 n'a pas de provider et n'en a pas besoin.
 */
export type UxVersion = 'v1' | 'v2';

export const UxVersionContext = createContext<UxVersion>('v1');

export function useUxVersion(): UxVersion {
  return useContext(UxVersionContext);
}
